var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatatype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,1.6V0h-4.6h-0.3c-0.6,0-2.1,0-3.9,0C3.5,0,0,0,0,0v20v0.1h15.8v-1.6H20v-17H15.8z M7.5,17.8 c-0.3,0.3-0.7,0.4-1.3,0.4H1.8V1.8c1,0,2.3,0,5.3,0c1.7,0,1.8,0,2.4,0l0,3.5l0,0.5c0,0,0,0.3-0.2,0.5c0,0.1-0.1,0.1-0.2,0.1 C8.9,6.4,8.8,6.5,8.5,6.5h0H7.8v0.8v0.7v9l0,0l0,0C7.8,17,7.8,17.5,7.5,17.8z M18.2,16.8h-1.4h-0.8H9.5V8.2c1,0,1.6-0.4,1.6-1.4H12 v6.8h-1l0,1.7h3.9l0-1.7h-1V6.8h1.3h0.4l0,1.1h0.4h1.3l0-2.7h-1.6h-0.4h-3.9V3.3h2h2.9h0.8h1.4V16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatatype);
export default __webpack_public_path__ + "static/media/datatype.c8057e0e.svg";
export { ForwardRef as ReactComponent };